<template>
    <div>
        <v-cookie></v-cookie>
        <div class="place">
            <span>位置：</span>
            <ul class="placeul">
                <li><a href="#">首页</a></li>
                <li>短信</li>
                <li><a href="#">短地址群发结果</a></li>
            </ul>
        </div>
        <div id="usual1" class="usual">  
            <div class="formbody">            
            <table class="tablelist" style="border-collapse:collapse;table-layout:fixed;">
                <thead>
                <tr>
                    <th width="15%">批次号(点击查看)</th>
                    <th width="25%">短信内容</th>
                    <th width="15%">原地址</th>
                    <th width="5%">状态</th>
                    <th width="15%">提交时间</th>
                    <th width="6%">有效天数</th>
                    <th width="6%">点击号码数</th>
                    <th width="6%">总点击数</th>
                </tr>
                </thead>
                <tbody>
                
                <tr v-for="(item,index) in shortSmsTaskList" :class="{odd:index%2!=0}">
                    <td width="15%"><a href="javascript:;" @click="shortSmsVisit(item.smsid)">{{item.smsid}}</a></td> 
                    <td width="25%" >{{item.content}}</td>
                    <td width="15%">{{item.srcUrl}}</td>
                    <td width="5%" ><ol v-if="item.state==1">审核通过</ol><ol v-else-if="item.state==-1">审核未过</ol><ol v-else>未审核</ol></td>
                    <td width="15%">{{item.createTime}}</td>
                    <td width="6%">{{item.urlDate}}</td>
                    <td width="6%">{{item.clickMobileCount}}</td>
                    <td width="6%">{{item.clickCount}}</td>
                </tr>
                </tbody>
            </table>
            <div class="pagin">
                <el-pagination
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="pageIndex"
                    :page-sizes="[50]"
                    :page-size="50"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="totalCount">
                </el-pagination>
            </div>
            <div class="jian">&nbsp;</div>        
            </div> 

            <div style="position: fixed; width:100%; height:100%; z-index:9999; background:rgb(51, 51, 51); opacity: 0.3; 
                top: 0; left: 0;display: block;" v-show="loadingShow"></div>
            <div style="position:fixed; left: 50%; top:50%; transform: translate3d(-50%, -50%, 0px); -ms-transform: translate3d(-50%, -50%, 0px);
                -webkit-transform: translate3d(-50%, -50%, 0px); z-index: 10000;" v-show="loadingShow">
                <i class="el-icon-loading" style="font-size: 40px;color:coral;"></i>
                <div style="margin-left:-20px;color:coral;"><span style="font-size: 13px;">查询中,请稍后...</span></div>
            </div>

        </div> 
    </div>
</template>
<script>
import cookie from '@/components/cookie.vue'
export default {
    components : {
        'v-cookie' : cookie,
    },
    data(){
        return{
            pageIndex:0,
            totalCount:0,
            shortSmsTaskList:[],
            loadingShow: true,
            state:-100,
        }
    },
    mounted(){
        this.pageChange(1);
    },
    methods:{
        handleSizeChange(val){
            this.pageChange(val);
        },
        handleCurrentChange(val){
            this.pageChange(val);
        },
        pageChange(pageIndex){
            this.loadingShow = true;
            let that = this;
            let data = {'pageSize':50,pageIndex:pageIndex,'state':this.state};
            this.$ajax({
                method: 'post',
                url: this.GLOBAL.serverSrc + '/sms/getpagesmsshorttask.json',
                data: data,
                headers: {
                    'Content-Type': 'application/json; charset=UTF-8',
                    'token' : this.GLOBAL.token
                }
            }).then(function(res) {
                if('0000000' == res.data.code)
                {
                    that.shortSmsTaskList = res.data.shortSmsTaskList;
                    that.pageIndex = parseInt(pageIndex);
                    that.totalCount = res.data.page.totalCount;
                    that.loadingShow = false;
                }
                else
                {
                    alert(res.data.msg)
                }
            })
        },
        shortSmsVisit(smsid){
            location.href = "smsshortvisit?smsid="+smsid
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/components/sms/smsshorttask.vue